// =============================================================================
// MÓDULO GALLERY MANAGER
// =============================================================================

export class GalleryManager {
    constructor(elements, config = {}) {
        this.elements = elements;
        this.config = {
            loop: true,
            margin: 10,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            responsive: {
                0: { items: 1 },
                768: { items: 2 },
                992: { items: 3 }
            },
            ...config
        };

        this.init();
    }

    init() {
        // Verificar si jQuery y Owl Carousel están disponibles
        if (typeof $ === 'undefined' || typeof $.fn.owlCarousel === 'undefined') {
            console.warn('jQuery o Owl Carousel no están disponibles');
            return;
        }

        this.initializeCarousels();
    }

    initializeCarousels() {
        this.elements.forEach((element, index) => {
            const $element = $(element);
            
            // Configuración específica por elemento si existe
            const elementConfig = element.dataset.galleryConfig ? 
                JSON.parse(element.dataset.galleryConfig) : {};
            
            const finalConfig = { ...this.config, ...elementConfig };

            // Inicializar Owl Carousel
            $element.owlCarousel(finalConfig);

            // Agregar eventos personalizados
            this.addCustomEvents($element, index);

            // Lazy loading para imágenes dentro del carousel
            this.initLazyLoading($element);
        });
    }

    addCustomEvents($element, index) {
        // Evento cuando cambia de slide
        $element.on('changed.owl.carousel', (event) => {
            const currentIndex = event.item.index;
            this.onSlideChange(currentIndex, index);
        });

        // Evento de hover para pausar autoplay
        $element.on('mouseenter', () => {
            $element.trigger('stop.owl.autoplay');
        });

        $element.on('mouseleave', () => {
            $element.trigger('play.owl.autoplay');
        });

        // Soporte para gestos táctiles mejorado
        this.addTouchSupport($element);
    }

    addTouchSupport($element) {
        let startX = 0;
        let startY = 0;

        $element.on('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        $element.on('touchmove', (e) => {
            if (!startX || !startY) return;

            const xDiff = startX - e.touches[0].clientX;
            const yDiff = startY - e.touches[0].clientY;

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                e.preventDefault(); // Prevenir scroll vertical
            }
        });
    }

    initLazyLoading($element) {
        const images = $element.find('img[data-src]');
        
        images.each((index, img) => {
            const $img = $(img);
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const $target = $(entry.target);
                        $target.attr('src', $target.data('src'));
                        $target.removeClass('lazy');
                        observer.unobserve(entry.target);
                    }
                });
            });

            observer.observe(img);
        });
    }

    onSlideChange(currentIndex, galleryIndex) {
        // Callback personalizable para cuando cambia de slide
        if (this.config.onSlideChange) {
            this.config.onSlideChange(currentIndex, galleryIndex);
        }

        // Trigger evento personalizado
        document.dispatchEvent(new CustomEvent('gallerySlideChange', {
            detail: { currentIndex, galleryIndex }
        }));
    }

    // Métodos públicos para controlar las galerías
    goToSlide(galleryIndex, slideIndex) {
        if (this.elements[galleryIndex]) {
            $(this.elements[galleryIndex]).trigger('to.owl.carousel', [slideIndex, 300]);
        }
    }

    playAutoplay(galleryIndex) {
        if (this.elements[galleryIndex]) {
            $(this.elements[galleryIndex]).trigger('play.owl.autoplay');
        }
    }

    stopAutoplay(galleryIndex) {
        if (this.elements[galleryIndex]) {
            $(this.elements[galleryIndex]).trigger('stop.owl.autoplay');
        }
    }

    destroy() {
        this.elements.forEach(element => {
            const $element = $(element);
            if ($element.hasClass('owl-loaded')) {
                $element.trigger('destroy.owl.carousel');
            }
        });
    }
}